import host from "@/common/config";
import wx from "weixin-js-sdk";

/**
 * 工具
 * */
let utils = {
    fetchData(url, data, type = 'data') {
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'POST', // or 'PUT'
                headers: {
                    'Content-Type': type == 'form'? 'application/x-www-form-urlencoded; charset=UTF-8' : 'application/json',
                },
                body: type == 'form'? data : JSON.stringify(data),
            })
                .then(response => {
                    // console.log(response)
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    resolve(response.json());

                })
                .catch(error => reject(error));
        });
    },
    isInWexin() {
        if(navigator.userAgent.toLowerCase().indexOf("micromessenger")>=0) return true;
        return false;
    },
    wxShare(shareTitle,shareDesc,shareLink,shareImg) {
        utils.fetchData(
            host.mainUrl + '/api/wx_api/shareObjThird',
            {
                'url': window.location.href,
                'app_sid':'klfs'
            }).then(data => {
            console.log(data)
            if(data.status == 200) {
                // 微信认证
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
                    appId: data.payload.appId, // 必填，公众号的唯一标识
                    timestamp: data.payload.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.payload.nonceStr, // 必填，生成签名的随机串
                    signature: data.payload.signature, // 必填，签名，见附录1
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','editAddress','openAddress'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });

                wx.ready(function() {
                    // var shareTitle = "微淘客官方商城";
                    // var shareDesc = "好物尽在微淘客";
                    // var shareLink =  window.location.href;
                    // var shareImg = encodeURI("http://pic.usuz.cc/icon.png");

                    //分享到朋友圈
                    wx.onMenuShareTimeline({
                        title: shareTitle, // 分享标题
                        desc: shareDesc, // 分享描述
                        link: shareLink, // 分享链接
                        imgUrl: shareImg, // 分享图标
                        success: function () {
                            // alert('已分享');
                        },
                        cancel: function () {
                            // alert('已取消');
                        }
                    });
                    //分享给微信好友
                    wx.onMenuShareAppMessage({
                        title: shareTitle, // 分享标题
                        desc: shareDesc, // 分享描述
                        link: shareLink, // 分享链接
                        imgUrl: shareImg, // 分享图标
                        success: function () {
                            // alert('已分享');
                        },
                        cancel: function () {
                            // alert('已取消');
                        }
                    });
                });

                wx.error(function(res){
                    console.log(res)
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    // alert("信息验证失败！")
                });

            }
        })
    },
    picUrlTrans(picUrl, url) {
        if(picUrl.indexOf('http') >= 0) {
            return picUrl;
        } else {
            return url + picUrl;
        }
    },
    getDateHandle(d) {
        const currentDate = new Date(d);
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1; // 注意月份从0开始，所以要加1
        const date = currentDate.getDate();
        return year + '-' + (month.toString().length > 1? month : '0' + month) + '-' + (date.toString().length > 1? date : '0' + date)
    },
    parseURL(url) {
        var a =  document.createElement('a');
        a.href = url;
        return {
            source: url,
            protocol: a.protocol.replace(':',''),
            host: a.hostname,
            port: a.port,
            query: a.search,
            params: (function(){
                var ret = {},
                    seg = a.search.replace(/^\?/,'').split('&'),
                    len = seg.length, i = 0, s;
                for (;i<len;i++) {
                    if (!seg[i]) { continue; }
                    s = seg[i].split('=');
                    ret[s[0]] = s[1];
                }
                return ret;
            })(),
            file: (a.pathname.match(/\/([^/?#]+)$/i) || [''])[1],
            hash: a.hash.replace('#',''),
            path: a.pathname.replace(/^([^/])/,'/$1'),
            relative: (a.href.match(/tps?:\/\/[^/]+(.+)/) || [''])[1],
            segments: a.pathname.replace(/^\//,'').split('/')
        };
    },
    // 符号替换
    timeReplace(str) {
      return str.replace(/-/g, '/')
    },
    // 是否是json对象
    isJSON: function(str) {
        if (typeof str == 'string') {
            try {
                var obj=JSON.parse(str);
                if(typeof obj == 'object' && obj ){
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                return false;
            }
        }
    },
    // 是否是对象
    isObject: function(value) {
        return toString.call(value) === '[object Object]'
    },
    // 是否数组
    isArray: function(value) {
        return Array.isArray(value)
    },
    // 是否是字符串
    isString: function(value) {
        return toString.call(value) === '[object String]'
    },
    // 不是空对象
    objIsNotEmpty:function(obj){
        if(obj==null || obj==undefined ){
            return false;
        }
        if(JSON.stringify(obj)=="{}"){
            return false;
        }
        return true;
    },
    // 多位小数转 2位
    price2dot(n) {
      return  parseFloat(Number(n).toFixed(2))
    },
    // 获取今天
    getToday() {
        let dd = new Date();
        const y = dd.getFullYear()
        const m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 // 获取当前月份的日期，不足10补0
        const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() // 获取当前几号，不足10补0
        return y + '/' + m + '/' + d
    },
    /**
     ** 加法函数，用来得到精确的加法结果
     ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
     ** 调用：accAdd(arg1,arg2)
     ** 返回值：arg1加上arg2的精确结果
     **/
    add(arg1, arg2) {
        var r1, r2, m, c;
        try {
            r1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
            r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
            var cm = Math.pow(10, c);
            if (r1 > r2) {
                arg1 = Number(arg1.toString().replace(".", ""));
                arg2 = Number(arg2.toString().replace(".", "")) * cm;
            } else {
                arg1 = Number(arg1.toString().replace(".", "")) * cm;
                arg2 = Number(arg2.toString().replace(".", ""));
            }
        } else {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", ""));
        }
        return Number((arg1 + arg2) / m);
    },
    /**
     ** 减法函数，用来得到精确的减法结果
     ** 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
     ** 调用：accSub(arg1,arg2)
     ** 返回值：arg1加上arg2的精确结果
     **/
    reduce(arg1, arg2) {
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2;
        return Number(((arg1 * m - arg2 * m) / m).toFixed(n));
    },

    /**
     ** 乘法函数，用来得到精确的乘法结果
     ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
     ** 调用：accMul(arg1,arg2)
     ** 返回值：arg1乘以 arg2的精确结果
     **/
    mul(arg1, arg2) {
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        }
        catch (e) {
            console.info(e)
        }
        try {
            m += s2.split(".")[1].length;
        }
        catch (e) {
            console.info(e)
        }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },
    /**
     ** 除法函数，用来得到精确的除法结果
     ** 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
     ** 调用：accDiv(arg1,arg2)
     ** 返回值：arg1除以arg2的精确结果
     **/

    div(arg1, arg2) {
        var t1 = 0, t2 = 0, r1, r2;
        try {
            t1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
            console.info(e)
        }
        try {
            t2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
            console.info(e)
        }
        r1 = Number(arg1.toString().replace(".", ""));
        r2 = Number(arg2.toString().replace(".", ""));
        return Number((r1 / r2) * Math.pow(10, t2 - t1));
    }
}

//给Number类型增加一个add方法，调用起来更加方便。
Number.prototype.add = function (arg) {
    return utils.add(arg, this);
};
// 给Number类型增加一个mul方法，调用起来更加方便。
Number.prototype.reduce = function (arg) {
    return utils.reduce(this, arg);
};
// 给Number类型增加一个mul方法，调用起来更加方便。
Number.prototype.mul = function (arg) {
    return utils.mul(arg, this);
};
//给Number类型增加一个div方法，调用起来更加方便。
Number.prototype.div = function (arg) {
    return utils.div(this, arg);
};
// 获取字符串长度
String.prototype.getLen = function() {
    var len = 0;
    for (var i=0; i<this.length; i++) {
        if (this.charCodeAt(i)>127 || this.charCodeAt(i)==94) {
            len += 2;
        } else {
            len ++;
        }
    }
    return len;
}

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function(fmt) { //
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

// 微信分享
function shareToWx() {
    var shareTitle = '快乐番薯官方网站_全国唯一招商中心_奶茶品牌加盟店_奶茶行业十佳品牌_厦门快乐番薯股份有限公司';
    var shareDesc = '快乐番薯官方网站_全国唯一招商中心_奶茶品牌加盟店_奶茶行业十佳品牌_厦门快乐番薯股份有限公司';
    var shareLink = window.location.href;
    var shareImg = encodeURI('https://www.klfspp.com/images/shareImg.png');
    utils.wxShare(shareTitle,shareDesc,shareLink,shareImg);  // 引入微信分享功能（js-sdk）
}
if(utils.isInWexin()) shareToWx();

export default utils
